import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
} from "@mui/material";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { API_URI } from "../../constants/GlobalConstants";
import {
  fetchCustomSchedules,
  fetchSchedules,
} from "../../redux/actions/SchedulesActions";
import { Link } from "react-router-dom";
import CustomScheduleModal from "./modals/CustomScheduleModal";
import EditEventModal from "./modals/EditEventModal";
import PrintScheduleModal from "./modals/PrintScheduleModal";
import { fetchAppSettings } from "../../redux/actions/UserSettingsActions";

const AllSchedulesComp = () => {
  const { schedules, loading, error } = useSelector((state) => state.schedules);
  const { customSchedules } = useSelector((state) => state.customSchedules);
  const [openPrintModal, setOpenPrintModal] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [statusFilter, setStatusFilter] = useState("");
  const userLogin = useSelector((state) => state.userSignIn);
  const { userInfo } = userLogin;
  const { settings } = useSelector((state) => state.appSettings); // Adjust the state path if needed
  const timezone = settings?.timezone || "UTC"; // Default to UTC if not available
  const dispatch = useDispatch();
  const localizer = momentLocalizer(moment);
  const now = new Date();
  const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  const [openCustomScheduleModal, setOpenCustomScheduleModal] = useState(false);
  const [customSchedule, setCustomSchedule] = useState({
    scheduledDate: "",
    orderTag: "",
    description: "",
    orderStatus: "",
    triggered: false,
    notificationSent: false,
  });
  useEffect(() => {
    dispatch(fetchSchedules(startOfMonth, endOfMonth, "month", statusFilter));
    dispatch(fetchCustomSchedules(startOfMonth, endOfMonth, "month", ""));
  }, [statusFilter]);

  useEffect(() => {
    dispatch(fetchAppSettings());
  }, []);

  const eventStyleGetter = (event) => {
    let backgroundColor;
    switch (event.statusToUpdate) {
      case "ready_to_process":
        backgroundColor = "#ffcc00"; // Yellow
        break;
      case "processing":
        backgroundColor = "#6a5acd"; // Blue
        break;
      case "processed":
        backgroundColor = "#00bfff"; // Sky Blue
        break;
      case "delivered":
        backgroundColor = "#32cd32"; // Green
        break;
      case "onHold":
        backgroundColor = "#ff6347"; // Red
        break;
      default:
        backgroundColor = "#20c997";
    }

    return {
      style: {
        backgroundColor,
        color: "white",
        borderRadius: "8px",
        padding: "4px",
        fontWeight: "bold",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
        transition: "all 0.3s ease",
        fontSize: "11px",
      },
    };
  };

  const events = [
    ...(schedules?.map((schedule) => {
      const eventDate = new Date(schedule.scheduledDate);
      console.log("Event Date:", eventDate);
      return {
        title: `Order ${schedule.orderId?.tag || "N/A"} - ${
          schedule.statusToUpdate
        }`,
        start: eventDate,
        end: eventDate,
        statusToUpdate: schedule.statusToUpdate,
        remark: schedule.remark,
        orderId: schedule.orderId?._id || null,
        _id: schedule._id,
        orderTag: schedule.orderId?.tag || "N/A",
        dealerName: schedule.orderId?.dealerName || "N/A",
        orderStatus: schedule.orderId?.orderStatus || "N/A",
        type: "Order-Based",
      };
    }) || []),

    ...(customSchedules?.map((custom) => {
      const eventDate = new Date(custom.scheduledDate);
      console.log("Custom Event Date:", eventDate);
      return {
        title: `Custom: ${custom.description}`,
        start: eventDate,
        end: eventDate,
        statusToUpdate: custom.orderStatus,
        remark: custom.description,
        orderId: null,
        _id: custom._id,
        orderTag: custom.orderTag,
        dealerName: "Custom",
        orderStatus: custom.orderStatus || "N/A",
        type: "Custom",
      };
    }) || []),
  ];

  const handleEventSelect = (event) => {
    setCurrentEvent(event);
    setOpenModal(true);
  };

  const handleSave = async () => {
    try {
      let response;
      if (currentEvent.type === "Custom") {
        // For Custom Schedule
        response = await axios.put(
          `${API_URI}/api/schedules/update-custom-event`,
          {
            scheduleId: currentEvent._id,
            description: currentEvent.remark,
            scheduledDate: currentEvent.start,
            orderStatus: currentEvent.statusToUpdate,
          },
          {
            headers: {
              Authorization: `Bearer ${userInfo.token}`,
            },
          }
        );
      } else {
        // For Order-Based Schedule
        response = await axios.put(
          `${API_URI}/api/schedules/update-event`,
          {
            eventId: currentEvent._id,
            scheduledDate: currentEvent.start,
            statusToUpdate: currentEvent.statusToUpdate,
            remark: currentEvent.remark,
          },
          {
            headers: {
              Authorization: `Bearer ${userInfo.token}`,
            },
          }
        );
      }

      setOpenModal(false);
    } catch (error) {
      console.error("Error updating event:", error);
    } finally {
      dispatch(fetchSchedules(startOfMonth, endOfMonth, "month", statusFilter));
      dispatch(fetchCustomSchedules(startOfMonth, endOfMonth, "month", ""));
    }
  };
  console.log(currentEvent);

  const handleDelete = async () => {
    if (!currentEvent) {
      return;
    }

    try {
      let response;
      if (currentEvent.type === "Custom") {
        // For Custom Schedule
        response = await axios.delete(
          `${API_URI}/api/schedules/delete-custom-event`,
          {
            data: { eventId: currentEvent._id },
            headers: {
              Authorization: `Bearer ${userInfo.token}`,
            },
          }
        );
      } else {
        // For Order-Based Schedule
        response = await axios.delete(`${API_URI}/api/schedules/delete-event`, {
          data: { eventId: currentEvent._id },
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        });
      }

      // Refresh schedules after delete
      setOpenModal(false);
      setOpenCustomScheduleModal(false);
    } catch (error) {
      console.error("Error deleting event:", error);
    } finally {
      dispatch(fetchSchedules(startOfMonth, endOfMonth, "month", statusFilter));
      dispatch(fetchCustomSchedules(startOfMonth, endOfMonth, "month", ""));
    }
  };

  const handleRangeChange = (range) => {
    let start, end, view;
    if (Array.isArray(range)) {
      start = range[0];
      end = range[range.length - 1];
      view = "week";
    } else {
      start = range.start;
      end = range.end;
      view = "month";
    }
    dispatch(fetchSchedules(start, end, view, statusFilter));
    dispatch(fetchCustomSchedules(start, end, view, ""));
  };

  const handleCustomScheduleClick = (date) => {
    setOpenCustomScheduleModal(true);
    setCustomSchedule({
      scheduledDate: moment(date).tz(timezone).format("YYYY-MM-DD"),
      statusToUpdate: "ready_to_process",
      remark: "",
      orderTag: "",
    });
  };
  const handleSelectSlot = ({ start }) => {
    handleCustomScheduleClick(moment(start).toDate());
  };

  const handleSaveCustomSchedule = async () => {
    try {
      const response = await axios.post(
        `${API_URI}/api/schedules/create-custom-schedule`,
        customSchedule,
        {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        }
      );
      dispatch(fetchCustomSchedules(startOfMonth, endOfMonth, "month", ""));
      setOpenCustomScheduleModal(false);
    } catch (error) {
      console.error("Error creating custom schedule:", error);
    } finally {
      setOpenCustomScheduleModal(false);
    }
  };

  const handlePrintSchedule = async (startDate, endDate) => {
    try {
      const response = await axios.post(
        `${API_URI}/api/schedules/schedule-pdf-download`,
        { startDate, endDate }, // Send data in request body
        {
          responseType: "arraybuffer", // Expect binary data
          headers: {
            Authorization: `Bearer ${userInfo.token}`, // Include token
          },
        }
      );

      // Create a Blob from the received ArrayBuffer
      const blob = new Blob([response.data], { type: "application/pdf" });

      // Create a link element to trigger the download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Schedule_${startDate}_${endDate}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading schedule:", error);
    } finally {
      setOpenPrintModal(false);
    }
  };

  return (
    <div
      style={{
        height: "80vh",
        margin: "20px",
        backgroundColor: "#f4f4f4",
        borderRadius: "15px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <FormControl style={{ minWidth: "200px" }}>
          <InputLabel>Status</InputLabel>
          <Select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            label="Status"
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="ready_to_process">Ready to Process</MenuItem>
            <MenuItem value="processing">Processing</MenuItem>
            <MenuItem value="processed">Processed</MenuItem>
            <MenuItem value="delivered">Delivered</MenuItem>
            <MenuItem value="onHold">On Hold</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div style={{ flexGrow: 1, overflow: "auto" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpenPrintModal(true)}
          style={{ marginBottom: "10px" }}
        >
          Print Schedule
        </Button>
        <PrintScheduleModal
          open={openPrintModal}
          onClose={() => setOpenPrintModal(false)}
          onPrint={handlePrintSchedule}
        />{" "}
        {/* Allow the calendar to grow inside the container */}
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          style={{
            height: "100%",
            backgroundColor: "white",
            color: "#333",
            borderRadius: "10px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.05)",
          }}
          eventPropGetter={eventStyleGetter}
          views={["month", "week", "day"]}
          defaultView="month"
          onSelectEvent={handleEventSelect} // Handle click on existing events
          onSelectSlot={handleSelectSlot} // Handle click on empty slots
          selectable={true} // Make the calendar cells selectable (empty slots)
          onRangeChange={handleRangeChange} 
        />
      </div>
      {/* Custom Schedule Modal */}
      <CustomScheduleModal
        open={openCustomScheduleModal}
        onClose={() => setOpenCustomScheduleModal(false)}
        customSchedule={customSchedule}
        setCustomSchedule={setCustomSchedule}
        onSave={handleSaveCustomSchedule}
      />
      <EditEventModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        currentEvent={currentEvent}
        setCurrentEvent={setCurrentEvent}
        onSave={handleSave}
        onDelete={handleDelete}
      />{" "}
    </div>
  );
};

export default AllSchedulesComp;